import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ServerService} from "./ServerService";

@Injectable({
  providedIn: 'root'
})
export class AreasDestinoService extends ServerService {
  constructor(private httpCliente: HttpClient) {
    super(httpCliente);
  }

  liste() {
    return this.obtenha('/areas-destino', {})
  }

  listeCategorias() {
    return this.obtenha('/areas-destino/categorias', {})
  }

  salveArea(area: any): Promise<any> {
    return this.facaPost('/areas-destino', area);
  }

  removaArea(area: any): Promise<any> {
    return this.facaPost(`/areas-destino/${area.id}/remova`, {});
  }
}
